(function () {
  function getQuantity(btn) {
    var inputId = btn.getAttribute('data-qty-input');
    if (!inputId) return 1;
    var input = document.getElementById(inputId);
    var qty = input ? parseInt(input.value, 10) : 1;
    return (qty && qty > 0) ? qty : 1;
  }

  function submitToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (data) {
          throw new Error(data.description || data.message || 'Could not add to cart');
        });
      }
      return res.json();
    });
  }

  function withBusyState(btn, fn) {
    btn.setAttribute('disabled', 'true');
    var originalText = btn.textContent;
    btn.textContent = '…';
    fn()
      .catch(function (err) {
        alert(err.message || 'Sorry, this item could not be added to your cart.');
      })
      .finally(function () {
        btn.removeAttribute('disabled');
        btn.textContent = originalText;
      });
  }

  function addToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    withBusyState(btn, function () {
      return submitToCart(variantId, getQuantity(btn)).then(function () {
        window.location.href = '/cart';
      });
    });
  }

  function buyNow(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    withBusyState(btn, function () {
      return submitToCart(variantId, getQuantity(btn)).then(function () {
        window.location.href = '/checkout';
      });
    });
  }

  function stepQuantity(btn, direction) {
    var inputId = btn.getAttribute(direction === 1 ? 'data-qty-increase' : 'data-qty-decrease');
    var input = inputId ? document.getElementById(inputId) : btn.parentElement.querySelector('.qty-input');
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var current = parseInt(input.value, 10) || min;
    var next = current + direction;
    input.value = next < min ? min : next;
  }

  function switchGalleryImage(thumb) {
    var fullSrc = thumb.getAttribute('data-full-src');
    var mainImg = document.getElementById('ProductMainImage');
    if (!fullSrc || !mainImg) return;
    mainImg.src = fullSrc;
    var thumbs = thumb.parentElement.querySelectorAll('.product-thumb');
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  }

  // Event delegation on document — works even when Shopify's Theme Editor
  // re-renders sections dynamically (section.load events), unlike listeners
  // bound directly to buttons at page load.
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn) { e.preventDefault(); addToCart(addBtn); return; }

    var buyBtn = e.target.closest('[data-buy-now]');
    if (buyBtn) { e.preventDefault(); buyNow(buyBtn); return; }

    var incBtn = e.target.closest('[data-qty-increase]');
    if (incBtn) { e.preventDefault(); stepQuantity(incBtn, 1); return; }

    var decBtn = e.target.closest('[data-qty-decrease]');
    if (decBtn) { e.preventDefault(); stepQuantity(decBtn, -1); return; }

    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) { e.preventDefault(); switchGalleryImage(thumb); return; }
  });
})();
